var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.14 10.726a3 3 0 0 0-4.656-3.784L15.228 22.027l-6.482-6.482a3 3 0 1 0-4.242 4.242l8.772 8.773a3 3 0 0 0 4.51-.167l14.355-17.667z",
    fill: "#FBED7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCheck);
export default __webpack_public_path__ + "static/media/yellow_check.e55e2bfed044b18de80a13fc68e37a8b.svg";
export { ForwardRef as ReactComponent };